/**
 * Converts a percentage value to a decimal value - used in DSV and SOV settings
 *
 * @param value - Percentage value to convert to decimal value
 * @returns Decimal value
 *
 * @example
 * percentageToDecimalValue(50) // returns 0.5
 * percentageToDecimalValue(75) // returns 0.75
 * percentageToDecimalValue(102.54) // returns 1.0254
 */

export const percentageToDecimalValue = (value: number): number => Math.round(value * 100) / 10_000;
